/**
 * Contentful asset IDs to download at build time and serve from Netlify CDN.
 *
 * Works for any file type: videos (videos.ctfassets.net), PDFs and other
 * downloads (downloads.ctfassets.net), or generic assets (assets.ctfassets.net).
 *
 * How to find the asset ID — it's the second path segment in any Contentful URL:
 *   https://videos.ctfassets.net/{spaceId}/{assetId}/{hash}/{filename}
 *   https://downloads.ctfassets.net/{spaceId}/{assetId}/{hash}/{filename}
 *                                              ↑ paste this
 *
 * Files are downloaded to public/cdn/{assetId}/{originalFilename} during the
 * Netlify build and served from the CDN edge at /cdn/{assetId}/{filename}.
 */
const CDN_ASSET_IDS = [
  // Videos
  "BmezNjCAwnQccXF4E9i5W", // Homepage hero video - EASTROOM DesignHotels FINAL.min
  "5aSxISqKqUAGjJRE2fMmtk", // EASTROOM Ecco FINAL.min
  "2OZ6M6LtykFgF15BCjN6xT", // KOTN- V3
  //PDFs
  "3NUZbBAJqAdDvIeHcCRfUK", // Events page — ER-EventDeck.pdf - previously hardcoded
  "56GlIbHmW777ts175LjNcI", // ER-Spaces-for Hire (compressed)
  "5oYXuJ6hDQIGJj8QUe0Ade", // 507 KING ALL OFFICES - compressed
  "1LKKEXCtTao8hCGncFiu3Y", // 68C PRIVATE OFFICE BROCHURE 2024
  "7foILCyQBUbG2b3MIAFzAX", // 507 Deck

];

module.exports = { CDN_ASSET_IDS };
